// extracted by mini-css-extract-plugin
export default {"summarySectionContent":"SummarySection_summarySectionContent__YLBdL"};